import { useTranslation } from 'react-i18next';
import { BrandLogo } from 'components/BrandLogo/BrandLogo';
import { readAppliedPlayerTheme, usesLogoTheme } from 'lib/playerTheme';
import styles from './BrandPlaceholder.module.css';

interface Props {
  /** Translation key of a line under the brand; none shows the brand alone. */
  messageKey?: string;
}

/**
 * The brand on a page with nothing else to show yet (work in progress, not
 * found): the app icon, the TOTTALO wordmark and one line. The legacy tottalo
 * theme keeps its original picture.
 */
export const BrandPlaceholder = ({ messageKey }: Props) => {
  const { t } = useTranslation();
  const theme = readAppliedPlayerTheme();

  if (usesLogoTheme(theme)) {
    return <img src="/photos/error-page-image.png" alt="Tottalo" />;
  }

  return (
    <div className={styles.placeholder}>
      <img
        className={styles.icon}
        src="/icon-192.png"
        alt=""
        aria-hidden="true"
      />
      <BrandLogo theme={theme} variant="login" />
      {messageKey && <p className={styles.message}>{t(messageKey)}</p>}
    </div>
  );
};
